module.exports = __webpack_public_path__ + "assets/signout.c8d03b11.svg";